<div class="d-flex justify-content-center " id="form-container">
  <div class="card mb-0">
    <h4 id="title" class="mb-1 mt-0"> <span class="fw-bolder">{{translate("title")}} </span></h4>
    <form [formGroup]="passwordUpdateForm" id="form" class="input-form">
      <au-password-input formControlName="oldPassword" #oldPasswordInput id="old-password-input"
        (enter)="tryTriggerSubmit($event)" [componentTranslationRoot]="oldPasswordTranslationRoot">
      </au-password-input>

      <div class="mt-1">
        <au-password-input formControlName="newPassword" #newPasswordInput id="new-password-input"
          [componentTranslationRoot]="newPasswordTranslationRoot" (enter)="tryTriggerSubmit($event)"></au-password-input>
      </div>

      <div class="mt-1">
        <au-password-input formControlName="confirmPassword" #newPasswordConfirmationInput
          id="new-password-confirmation-input" [componentTranslationRoot]="confirmPasswordTranslationRoot"
          (enter)="tryTriggerSubmit($event)">
        </au-password-input>
      </div>

      <div class="mb-1 mt-1">
        <au-notification-bar #notificationBar> </au-notification-bar>
      </div>

      <div id="buttons-container">
        <button type="button" id="back-button" rippleEffect class="btn round btn-outline-danger w-100" (click)="goBack()">
          <span>{{translate('cancel') }}</span>
        </button>

        <button type="submit" rippleEffect class="btn round btn-primary w-100" (click)="tryTriggerSubmit($event)"
          id="submit-button" [disabled]="isFormSubmitDisabled">{{ translate("change-password") }}
        </button>
      </div>

    </form>
  </div>
</div>
